import normalizeWheel from 'normalize-wheel'
import { lerp, mouse } from '@/js/utils'

export default function (parentEl, start) {
  const canvas = document.createElement('canvas')
  let box = parentEl.getBoundingClientRect()

  parentEl.style.display = 'flex'
  parentEl.style.alignItems = 'center'
  parentEl.style.justifyContent = 'center'
  canvas.style.borderRadius = '50%'
  canvas.style.width = box.width * 0.6 + 'px'
  canvas.style.height = box.width * 0.6 + 'px'
  canvas.width = box.width * 0.6 * 2
  canvas.height = box.width * 0.6 * 2
  parentEl.append(canvas)

  const ctx = canvas.getContext('2d')
  const cBox = canvas.getBoundingClientRect()

  let wheel = 0
  window.addEventListener('wheel', e => { wheel += normalizeWheel(e).pixelY })

  window.addEventListener('resize', () => {
    box = parentEl.getBoundingClientRect()
    canvas.style.width = box.width * 0.6 + 'px'
    canvas.style.height = box.width * 0.6 + 'px'
    canvas.width = box.width * 0.6 * 2
    canvas.height = box.width * 0.6 * 2
  })

  const n = 60
  let w = 0
  let m = {
    x: (mouse.x - cBox.left) * 2,
    y: (mouse.y - cBox.top) * 2
  }

  start()

  return () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.lineWidth = 3
    ctx.strokeStyle = '#fff'

    m = {
      x: lerp(m.x, (mouse.x - cBox.left) * 2, 0.1),
      y: lerp(m.y, (mouse.y - cBox.top) * 2, 0.1)
    }
    w = lerp(w, wheel, 0.1)

    for (const i in Array(n).fill(0)) {
      const x = Math.sin(Math.PI * 2 * i / n + w / 3000) * canvas.width / 2 + canvas.width / 2
      const y = Math.cos(Math.PI * 2 * i / n + w / 3000) * canvas.height / 2 + canvas.height / 2

      ctx.beginPath()
      ctx.moveTo(m.x, m.y)
      ctx.lineTo(x, y)
      ctx.stroke()
    }
  }
}
